'use client';

import Script from 'next/script';
import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

type EyeAbleScriptsProps = {
    domainConfiguration?: DomainConfigurationDto;
};

/**
 * EyeAble Scripts for the cinema website.
 *
 * @constructor
 */
const EyeAbleScripts: React.FC<EyeAbleScriptsProps> = ({ domainConfiguration }) => {
    if (!domainConfiguration) return null;

    if (!domainConfiguration.websiteConfiguration.isEyeAbleEnabled) return null;
    const domain = domainConfiguration.domain?.replace('www.', '');

    return (
        <>
            <Script
                async
                src={`https://cdn.eye-able.com/configs/www.${domain}.js`}></Script>
            <Script
                async
                src="https://cdn.eye-able.com/public/js/eyeAble.js"></Script>
        </>
    );
};

export default EyeAbleScripts;
